import React, { useEffect, useState } from 'react';
import Helmet from 'react-helmet';
import gsap from 'gsap';

import SlideLayout from '../components/slide-layout';
import { showNewContentBanner } from '../components/new-content';
import { ANIMATION_DEFAULT_DELAY } from '../constants';

import SvgContent from '../svgs/start2024.svg';
import NewContent from '../images/new-content-cover.svg';
import thumbnail from '../../static/thumbnails/ZMG_E-Paper-Qualitaeten2024-start.png';

const startAnimation = (timeline) => {
  // prettier-ignore
  timeline
    .delay(ANIMATION_DEFAULT_DELAY)
    .from('[data-gsap=line-bottom]', { translateX: '100%', duration: 2.5 })
    .from('#Background', { translateY: '100%', duration: 2 }, '>-1.5')
    .from('[data-gsap=A-YEAR]', { translateY: '100%', duration: 1 }, '>-1.4')
    .from('[data-gsap=B-YEAR]', { translateY: '100%', duration: 1 }, '>-0.5')
    .from('[data-gsap=Headline]', {translateX: '50%', opacity:0 , duration: 1 },'>-1')
    .from('[data-gsap=C-YEAR]', { translateY: '100%', duration: 1 }, '>-0.7')
    .from('[data-gsap=Headline-year]', {translateX: '100%', opacity:0 , duration: 1 })
    .from('[data-gsap=D-YEAR]', { translateY: '100%', duration: 1 },'>-1.5')


    .from('[data-gsap=A-Icons1-Line]', {drawSVG: '0', duration: 1.5},'>-1.0')
    .from(['[data-gsap=A-Icons1-Light]', '[data-gsap=A-Icons1-Bubble]'], {drawSVG: '0', duration: 1},'>-1.2')

    .fromTo('[data-gsap=A-Icons2-Line]', {drawSVG:"100% 100%"},{drawSVG: "0% 100% ", duration: 1.5},'>-1.0')
    .from('[data-gsap=A-Icons2-Symbol]', {drawSVG: '0', duration: 1},'>-0.5')


    .fromTo('[data-gsap=B-Icons-Line]', {drawSVG:"0% 0% "},{drawSVG: "0% 100% ", duration: 1.5},'>-1.0')
    .from(['[data-gsap=B-Icons-Cloud]','[data-gsap=B-Icons-Play]', '[data-gsap=B-Icons-Check]'], {drawSVG: '0', duration: 1},'>-0.6')

    .fromTo('[data-gsap=C-Icons-Line]', {drawSVG:"100% 100%"},{drawSVG: "0% 100%", duration: 1},'>-1')
    .from(['[data-gsap=C-Icons-Hand]'], {drawSVG: '0', duration: 1},'>-0.5')

    .fromTo('[data-gsap=D-Icons-Line]', {drawSVG:"0% 0%"},{drawSVG: "0% 100%", duration: 1.5},'>-1.2')
    .from(['[data-gsap=D-Icons-Bubble]','[data-gsap=D-Icons-Glas]'], {drawSVG: '0', duration: 1},'>-0.6')

    .from(['[data-gsap=A-Icon-effect_1]','[data-gsap=A-Icon-effect_2]', '[data-gsap=A-Icon-effect_3]','[data-gsap=A-Icon-effect_4]', '[data-gsap=A-Icon-effect_5]'],
      { stagger: {
        each: 0.1,
          from: 'center'
        }, drawSVG: 0},'>-0.4')
    .from('[data-gsap=subtitle]', {translateX: '50%', opacity:0 , duration: 1.5 },'>-4')


   // .from('[data-gsap=line-bottom]', { translateX: '100%', duration: 0.5 })
    //  .from('[data-gsap=solid-object-black]', { translateY: '100%', duration: 1.5 })
    //  .from('[data-gsap=solid-object-blue-back]', { translateY: '100%', duration: 1.5 }, '<')
    // .from('[data-gsap=solid-object-orange]', { translateY: '100%', duration: 1.5 }, '<+=0.25')
    // .from('[data-gsap=solid-object-grey]', { translateY: '100%', duration: 1.5 }, '<+=0.25')
    // .from('[data-gsap=solid-object-blue-front]', { translateY: '100%', duration: 1.5 }, '<+=0.25')
    // .from('[data-gsap=background-triangle]', { translateY: '100%', duration: 1.5 }, '<+=0.25')
    // .from('[data-gsap=title-header]', { translateX: 1920, duration: 1.5 }, '<')
  // .from('[data-gsap=title-subheader]', { translateX: 1840, duration: 1.5 }, '<+=0.05');
};
const Slide = ({ location }) => {
  const timeline = gsap.timeline();
  const [openMenu, setOpenMenu] = useState(false);
  useEffect(() => startAnimation(timeline), [timeline]);

  const data = {
    titleSeo: `E-Paper-Qualitäten`,
    title: (''),
    description: '',
    metaDescription: `„E-Paper-Qualitäten” ist eine Studie, die wertvolle Einblicke in Motive und Nutzungsgewohnheiten von E-Paper-Leserinnen und -Lesern der deutschen Zeitungen gibt.`,
    thumbnail: thumbnail,

  };
  return (
    <SlideLayout location={{pathname: '/presentation/'}} data={data} animation={timeline} openMenu={openMenu}>
      <Helmet>
        <link rel="canonical" href="https://www.epaperqualitaeten.de/presentation" />
      </Helmet>
      {/* <h1
        className="m-0 position-absolute"
        style={{ top: '33.5%', left: '6%', fontSize: '3.25rem', textTransform: 'uppercase' }}
      >
        <span className="font-weight-bold d-block">E-Paper-Qualitäten</span>
        <span className="font-weight-normal">2021</span>
      </h1> */}
      <SvgContent />
      {showNewContentBanner() && <NewContent className="new-content__start" onClick={() => setOpenMenu(true)} />}
    </SlideLayout>
  );
};

export default Slide;
